<template>
  <base-view>
    <div class="page-fill bg-gray-lighter">

      <!-- Hero -->
      <div
        class="relative w-full bg-center bg-cover"
        :style="{ backgroundImage: 'url(' + heroImage + ')' }"
      >
        <div class="absolute inset-0 hero-overlay"></div>
        <section class="relative flex flex-col items-center gap-4 max-w-3xl px-6 pt-14 pb-10 mx-auto text-center">
<h1 class="m-0 text-4xl font-extrabold leading-tight text-gray-900">Quick Tip Videos</h1>
          <p class="max-w-lg m-0 text-lg text-gray-700">
            Short walkthroughs to help you get the most out of your benefits account.
          </p>
        </section>
      </div>

      <!-- Video grid -->
      <div class="max-w-4xl mx-auto px-6 py-10 pb-16">
        <div class="video-grid">
          <button
            v-for="video in videos"
            :key="video.id"
            type="button"
            class="video-card"
            @click="openVideo(video)"
          >
            <div class="thumbnail-wrap">
              <img
                :src="'https://img.youtube.com/vi/' + video.id + '/mqdefault.jpg'"
                :alt="video.title"
                class="thumbnail"
              />
              <div class="play-overlay" aria-hidden="true">
                <div class="play-btn">&#9654;</div>
              </div>
            </div>
            <div class="video-title">{{ video.title }}</div>
          </button>
        </div>
      </div>

      <!-- Modal -->
      <transition name="modal-fade">
        <div
          v-if="selectedVideo"
          class="modal-backdrop"
          @click.self="closeVideo"
          role="dialog"
          aria-modal="true"
          :aria-label="selectedVideo.title"
        >
          <div class="modal-box">
            <div class="modal-header">
              <span class="modal-title">{{ selectedVideo.title }}</span>
              <button type="button" class="modal-close" @click="closeVideo" aria-label="Close video">✕</button>
            </div>
            <div class="modal-video">
              <iframe
                :src="embedSrc"
                :title="selectedVideo.title"
                allowfullscreen
                frameborder="0"
              ></iframe>
            </div>
          </div>
        </div>
      </transition>

    </div>
  </base-view>
</template>

<script>
import BaseView from "@/components/layout/BaseView.vue";
export default {
  name: "QuickTipVideos",
  components: { BaseView },
  data() {
    return {
      heroImage: require("@/assets/bg.jpg"),
      selectedVideo: null,
      videos: [
        { id: "oNiWTOrlBww", title: "Check Balance" },
        { id: "XOQtc1rzbyI", title: "Submit a Claim" },
        { id: "44AdnOh0kRs", title: "How to Register" },
        { id: "W3MoBg5nlTM", title: "Use Your Card" },
        { id: "EHaU1cvbDgc", title: "Upload Documentation" },
        { id: "YSAa54ORB5E", title: "Change Payment Method" }
      ]
    };
  },
  computed: {
    embedSrc() {
      if (!this.selectedVideo) return "";
      return `https://www.youtube.com/embed/${this.selectedVideo.id}?autoplay=1&rel=0&modestbranding=1`;
    }
  },
  methods: {
    openVideo(video) {
      this.selectedVideo = video;
      document.addEventListener("keydown", this.onKeydown);
    },
    closeVideo() {
      this.selectedVideo = null;
      document.removeEventListener("keydown", this.onKeydown);
    },
    onKeydown(e) {
      if (e.key === "Escape") this.closeVideo();
    }
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.onKeydown);
  }
};
</script>

<style scoped>
.page-fill { min-height: calc(100vh - 10rem); }


.hero-overlay {
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.62) 0%,
    rgba(255, 255, 255, 0.88) 45%,
    #fafafa 75%,
    #fafafa 100%
  );
}

/* Grid */
.video-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.25rem;
}
@media (min-width: 640px) {
  .video-grid { grid-template-columns: repeat(3, 1fr); }
}

.video-card {
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  text-align: left;
  font: inherit;
  -webkit-tap-highlight-color: transparent;
  outline: none;
}
.video-card:focus-visible .thumbnail-wrap {
  outline: 2px solid #096843;
  outline-offset: 2px;
}

.thumbnail-wrap {
  position: relative;
  border-radius: 0.625rem;
  overflow: hidden;
  background: #e5e7eb;
  aspect-ratio: 16 / 9;
}
.thumbnail {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.2s ease;
}
.video-card:hover .thumbnail { transform: scale(1.03); }

.play-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.18);
  opacity: 0;
  transition: opacity 0.2s ease;
}
.video-card:hover .play-overlay { opacity: 1; }

.play-btn {
  width: 2.75rem;
  height: 2.75rem;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.92);
  color: #096843;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 3px;
}

.video-title {
  font-size: 0.9375rem;
  font-weight: 600;
  color: #111827;
  line-height: 1.4;
}
.video-card:hover .video-title { color: #096843; }

/* Modal */
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
}
.modal-box {
  background: #111827;
  border-radius: 0.875rem;
  overflow: hidden;
  width: 100%;
  max-width: 52rem;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.5);
}
.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.875rem 1.25rem;
}
.modal-title {
  font-size: 0.9375rem;
  font-weight: 700;
  color: #ffffff;
}
.modal-close {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  font-size: 1rem;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  border-radius: 0.375rem;
  line-height: 1;
  transition: color 0.15s;
}
.modal-close:hover { color: #ffffff; }
.modal-video {
  position: relative;
  aspect-ratio: 16 / 9;
  width: 100%;
}
.modal-video iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;
  border: 0;
}

/* Transition */
.modal-fade-enter-active,
.modal-fade-leave-active { transition: opacity 0.2s ease; }
.modal-fade-enter,
.modal-fade-leave-to { opacity: 0; }
</style>
